import { IconProps } from "../../types/IconType";

const CheckIcon = ({ width, height, color = "#787486" }: IconProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="check_FILL0_wght300_GRAD0_opsz24 1">
        <path
          id="Vector"
          d="M8.75418 14.2223L16.6728 6.30372C16.8091 6.1674 16.971 6.09776 17.1584 6.09482C17.3459 6.09188 17.5107 6.16152 17.6529 6.30372C17.7951 6.44591 17.8662 6.60926 17.8662 6.79377C17.8662 6.97827 17.7951 7.14162 17.6529 7.28382L9.33414 15.6026C9.16843 15.7683 8.97511 15.8511 8.75418 15.8511C8.53325 15.8511 8.33993 15.7683 8.17423 15.6026L4.34715 11.7755C4.21082 11.6392 4.14354 11.4773 4.1453 11.2898C4.14707 11.1024 4.21905 10.9376 4.36124 10.7954C4.50345 10.6532 4.6668 10.5821 4.85129 10.5821C5.0358 10.5821 5.19915 10.6532 5.34134 10.7954L8.75418 14.2223Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export default CheckIcon;
